var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"footer-logo",attrs:{"src":_vm.$helper.getLinkToIlBucketFile('investing-live-logo.svg'),"alt":"investingLive"}})}
var staticRenderFns = []

export { render, staticRenderFns }